export const COMMAND_PALETTE_OPEN_EVENT = "cmdk:open";

/** Open the command palette from anywhere (e.g. the TopBar trigger). */
export function openCommandPalette() {
  window.dispatchEvent(new CustomEvent(COMMAND_PALETTE_OPEN_EVENT));
}
